"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeCustomerLabel = exports.customerToCode = exports.customerFromCode = void 0;
const errors_1 = require("@wolf/errors");
const models_1 = require("./models");
const utils_1 = require("./utils");
const types_1 = require("./types");
const customerAI = {
    '90': 'type',
    '20': 'sourceId',
    '251': 'workspaceId',
    '91': 'deliveryGroupId',
    '92': 'boxId',
    '93': 'productId',
    '94': 'index',
};
const customerFromCode = (code) => {
    try {
        const codes = (0, utils_1.stringToCodes)(code);
        if ('productId' in codes) {
            throw new errors_1.BadRequestError(errors_1.BAD_REQUEST_ERROR_CODES.BAD_PICKING_INPUT, 'Incorrect format');
        }
        const customer = codes.reduce((previousCodes, code) => {
            return {
                ...previousCodes,
                [customerAI[code.code]]: Number(code.value),
            };
        }, {});
        const customerParse = models_1.CustomerFromBarcode.safeParse(customer);
        if (!customerParse.success || customerParse.data.type !== Number(types_1.type.customer)) {
            throw new errors_1.BadRequestError(errors_1.BAD_REQUEST_ERROR_CODES.BAD_PICKING_INPUT, 'Invalid identifier');
        }
        return customerParse.data;
    }
    catch (error) {
        throw new errors_1.ApplicationError(`Unknown error ${error}`);
    }
};
exports.customerFromCode = customerFromCode;
const customerToCode = (customer) => {
    const swappedCustomerAI = Object.entries(customerAI).reduce((acc, [key, value]) => ({ ...acc, [value]: key }), {});
    const code = Object.keys(customer).reduce((previousCode, key) => {
        return (previousCode +
            '(' +
            swappedCustomerAI[key] +
            ')' +
            (0, utils_1.formatToCode)(customer[key]));
    }, '');
    return types_1.typeIA + types_1.type.customer + code;
};
exports.customerToCode = customerToCode;
const characterMap = {
    'á': 'a', 'é': 'e', 'í': 'i', 'ó': 'o', 'ú': 'u',
    'Á': 'A', 'É': 'E', 'Í': 'I', 'Ó': 'O', 'Ú': 'U',
    'ñ': 'n', 'Ñ': 'N', 'Ü': 'U', 'ü': 'u'
};
const normalizeCustomerLabel = (name) => name.split('').map(char => characterMap[char] || char).join('');
exports.normalizeCustomerLabel = normalizeCustomerLabel;
//# sourceMappingURL=customer.js.map